import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgxTolgeeModule } from "@tolgee/ngx";
import { RingingCall } from "../../../interfaces/remote-guidance";

/** Rings while a pair of glasses calls. Closes with `true` to answer, anything else to ignore. */
@Component({
	selector: "app-incoming-call-dialog",
	templateUrl: "./incoming-call-dialog.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton, MatIcon, NgxTolgeeModule],
})
export class IncomingCallDialogComponent implements OnInit, OnDestroy {
	readonly call = inject<RingingCall>(MAT_DIALOG_DATA);

	private audio: AudioContext | null = null;
	private ringTimer: ReturnType<typeof setInterval> | null = null;

	ngOnInit(): void {
		this.ring();
		this.ringTimer = setInterval(() => this.ring(), 2500);
	}

	ngOnDestroy(): void {
		if (this.ringTimer) {
			clearInterval(this.ringTimer);
		}
		void this.audio?.close().catch(() => undefined);
	}

	/** Two short tones, like a phone. The browser may refuse sound before any user gesture: the dialog stays. */
	private ring(): void {
		try {
			this.audio ??= new AudioContext();
			const start = this.audio.currentTime;
			[0, 0.5].forEach((offset) => {
				const oscillator = this.audio.createOscillator();
				const gain = this.audio.createGain();
				oscillator.frequency.value = 480;
				gain.gain.value = 0.08;
				oscillator.connect(gain).connect(this.audio.destination);
				oscillator.start(start + offset);
				oscillator.stop(start + offset + 0.35);
			});
		} catch {
			// No Web Audio (tests, old browsers): ring silently.
		}
	}
}
